/// <amd-module name="TFS/Admin/Common/Util/Telemetry/TelemetrySanitizer" />
import { caseInsensitiveContains } from "VSS/Core/Util/String";
import { ErrorMessageSearchString, ErrorMessageReturnString } from "TFS/Admin/Common/Constants/TelemetryConstants";

export class TelemetrySanitizer {
    CleanErrorMessage = (errorMessage?: string): string => {
        if (!errorMessage) {
            return "";
        }

        errorMessage = errorMessage.toString();

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.AccessDenied)) {
            return ErrorMessageReturnString.AccessDenied;
        }

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.UserNotAuthorized)) {
            return ErrorMessageReturnString.UserNotAuthorized;
        }

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.UserNeedsSignIn)) {
            return ErrorMessageReturnString.UserNeedsSignIn;
        }

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.UserCouldNotBeAdded)) {
            return ErrorMessageReturnString.UserCouldNotBeAdded;
        }

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.ActiveMemberNotAllowed)) {
            return ErrorMessageReturnString.ActiveMemberNotAllowed;
        }

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.IdentityMaterializationFailure)) {
            return ErrorMessageReturnString.IdentityMaterializationFailure;
        }

        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.AccountInsufficientPermission)) {
            return ErrorMessageReturnString.AccountInsufficientPermission;
        }

        // do upn check in the last step
        if (caseInsensitiveContains(errorMessage, ErrorMessageSearchString.UpnPresent)) {
            return ErrorMessageReturnString.UpnPresent;
        }

        return errorMessage;
    };
}
